import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import fieldConstants from '@/constants/fields';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import { removeFilterFromCohort } from '../actions';
import QueryFilterFieldTableCell from './QueryFilterFieldTableCell';
import QueryFilterOperatorTableCell from './QueryFilterOperatorTableCell';
import QueryFilterValuesTableCell from './QueryFilterValuesTableCell';
import CohortFilterAnd from '../components/CohortFilterAnd';

const QueryFilterTableRow = ({
  className,
  first,
  removeFilter,
  category,
  code,
  dictionaryCode,
  clauseUUID,
  filterUUID,
  canEdit,
  queryUUID,
  isEditing,
  validationErrors,
}) => {
  const intl = useIntl();
  const validationError = (validationErrors || []).find((e) => (
    e.context.filterUUID === filterUUID && (e.fields.includes(fieldConstants.FIELD)
    || e.fields.includes(fieldConstants.OPERATOR))));

  return (
    <Table.Row
      className={clsx('aridhia-query-filter-row', className)}
      verticalAlign="top"
      error={!(validationError === null || validationError === undefined)}
    >
      <Table.Cell
        colSpan="1"
        collapsing
        title={intl.formatMessage({ id: 'cohort.refine.and.tooltip' })}
        className="min-w-40"
      >
        <CohortFilterAnd isEditing={isEditing} first={first} />
      </Table.Cell>
      <QueryFilterFieldTableCell
        code={code}
        category={category}
        dictionaryCode={dictionaryCode}
        clauseUUID={clauseUUID}
        queryUUID={queryUUID}
        filterUUID={filterUUID}
      />
      <QueryFilterOperatorTableCell
        code={code}
        category={category}
        dictionaryCode={dictionaryCode}
        queryUUID={queryUUID}
        clauseUUID={clauseUUID}
        filterUUID={filterUUID}
      />
      <QueryFilterValuesTableCell
        code={code}
        category={category}
        dictionaryCode={dictionaryCode}
        queryUUID={queryUUID}
        clauseUUID={clauseUUID}
        filterUUID={filterUUID}
      />
      {canEdit && (
        <Table.Cell collapsing textAlign="center" verticalAlign="middle">
          <RowDeleteButton
            entity="query.filter"
            floated="right"
            onClick={() => removeFilter(category, code, queryUUID, clauseUUID, filterUUID, dictionaryCode)}
          />
        </Table.Cell>
      )}
    </Table.Row>
  );
};

const mapDispatchToProps = {
  removeFilter: removeFilterFromCohort,
};

export default connect(null, mapDispatchToProps)(QueryFilterTableRow);
